/* Consented first-block-touch journeys. Stores categories and article IDs, never URLs or customer data. */
(function () {
  'use strict';
  if (window.WynchJourneysV1) return;
  var KEY='wynch_journey_v1', state=null, pending=null, chain=Promise.resolve(), generation=0, loaded=false;
  var metaNode=document.getElementById('wynch-journey-page');
  var page=metaNode ? JSON.parse(metaNode.textContent) : {kind:'other',article:null};
  function allowed(){return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed());}
  function save(){if(allowed())try{sessionStorage.setItem(KEY,JSON.stringify(state));}catch(_){}}
  function valid(s){return s && typeof s.token==='string' && Date.now()-s.start<86400000 && Date.now()-s.last<1800000;}
  async function session(){
    if(!allowed())return null;
    if(valid(state))return state;
    if(pending)return pending;
    var current=generation;
    pending=(async function(){
      try{
        var saved=JSON.parse(sessionStorage.getItem(KEY)||'null');
        if(valid(saved)){state=saved;return state;}
        var r=await fetch(Shopify.routes.root+'apps/wynch-email/journey-session',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({version:1,device:/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1)?'mobile':'desktop'}),signal:AbortSignal.timeout(4000)});
        if(!r.ok||!allowed()||current!==generation)return null;
        var s=await r.json();if(typeof s.token!=='string'||!Number.isFinite(s.start))return null;
        state={token:s.token,start:s.start,last:Date.now(),block:false,sent:{},queue:[],count:0};save();return state;
      }catch(_){return null;}finally{pending=null;}
    })();return pending;
  }
  async function flush(s){
    while(allowed() && s===state && s.queue.length){
      try{var r=await fetch('https://wynch-email-os-connect.vercel.app/api/journey/event',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(s.queue[0]),keepalive:true});if(!r.ok){if(r.status===400){s.queue.shift();save();continue;}return;}s.queue.shift();save();}catch(_){return;}
    }
  }
  function emit(kind,article,once){
    chain=chain.then(async function(){
      var s=await session();if(!s||!allowed())return;
      if(once&&s.sent[once])return;
      if(kind==='block_shown'){if(s.block)return;s.block=true;}
      if(s.count>=200)return;
      s.count++;s.last=Date.now();if(once)s.sent[once]=true;
      s.queue.push({version:1,token:s.token,event_id:crypto.randomUUID(),kind:kind,article:article||null,at:new Date().toISOString()});save();await flush(s);
    }).catch(function(){});
    return chain;
  }
  async function cartAttribution(){
    var s=await session();if(!s||!allowed())return;
    if(window.WynchCommerceAnalyticsV2)await window.WynchCommerceAnalyticsV2.activate('journey',{token:s.token,start:s.start});
  }
  window.WynchJourneysV1={productAdded:function(token){if(valid(state)&&state.token===token)emit('added',null);},blockShown:function(){emit('block_shown',page.article);},quizProgress:function(stage){emit(stage,null,stage);}};
  document.addEventListener('click',function(e){var link=e.target.closest('a[id^="qa-section-heading-with-image-link-"], [data-wynch-footer-manifest-link]');if(link&&allowed())emit('block_clicked',null);},true);
  var observer=null;
  function observeFooter(){
    if(!allowed()||!window.IntersectionObserver)return;
    if(observer)observer.disconnect();
    observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(allowed()&&document.visibilityState==='visible'&&entry.isIntersecting&&entry.intersectionRatio>=0.5&&!entry.target.closest('[hidden]'))emit('block_shown',page.article);});},{threshold:[0.5]});
    document.querySelectorAll('[data-wynch-footer-manifest-link]').forEach(function(el){observer.observe(el);});
  }
  function start(){if(!allowed()||loaded)return;loaded=true;emit(page.kind,page.article).then(cartAttribution);observeFooter();}
  document.addEventListener('visibilitychange',observeFooter);
  function quizStarted(){
    if(page.kind!=='quiz'||!allowed()||document.visibilityState!=='visible')return;
    if(Array.from(document.querySelectorAll('.quiz-page-question')).some(function(el){return el.getClientRects().length>0&&!el.closest('[hidden]')&&getComputedStyle(el).visibility!=='hidden';}))emit('quiz_started',null,'quiz_started');
  }
  if(page.kind==='quiz')new MutationObserver(quizStarted).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','class','style']});
  document.addEventListener('quiz:finished',function(){emit('quiz_finished',null,'quiz_finished');});

  document.addEventListener('visitorConsentCollected',function(){if(allowed())start();else{generation++;state=null;loaded=false;try{sessionStorage.removeItem(KEY);}catch(_){}}});
  window.addEventListener('online',function(){if(state)chain=chain.then(function(){return flush(state);});});
  var attempts=0;(function ready(){start();if(!loaded&&++attempts<40)setTimeout(ready,250);})();
})();
